import { render, staticRenderFns } from "./RoomTypesForm.vue?vue&type=template&id=ccb8957a&"
import script from "./RoomTypesForm.vue?vue&type=script&lang=js&"
export * from "./RoomTypesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports